module.exports = __webpack_public_path__ + "static/media/track_truck.456681b2.png";